import React from 'react';
import styled from 'styled-components';
import { useClubContext } from './hooks/ClubContext';
import { ClubLink } from './types/clubLinksTypes';
import { InfoBlockLink } from 'Components/InfoBlock';
import { useHeaderContext } from 'Components/HeaderContext';

const StyledInfoBlockLink = styled(InfoBlockLink)``;

const InfoBlockItem = ({ text, pathName }: { text: string; pathName: ClubLink }): JSX.Element => {
    const { links } = useClubContext();
    const {
        trackingHelpers: {
            ga: { trackNonInteractiveGenericEvent },
        },
    } = useHeaderContext();

    return (
        <StyledInfoBlockLink
            data-testid="oww-header-info-block-helpcenter"
            href={links[pathName].path}
            onClick={() =>
                trackNonInteractiveGenericEvent('Header', {
                    action: 'Value propositon click',
                    label: 'Contact',
                })
            }
        >
            {text}
        </StyledInfoBlockLink>
    );
};

export default InfoBlockItem;
